import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Divider from 'LuxKit/Divider'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'

const FilterPanel = styled.div`
  ${mediaQueryUp.desktop} {
    position: sticky;
    top: ${props => props.theme.layout.headerFloatingOffset};
    padding: ${rem(16)} 0;
    max-height: calc((var(--vh) * 100) - ${props => props.theme.layout.headerFloatingOffset});
    overflow-y: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(12)};
  margin-bottom: ${rem(16)};
`

const CheckboxSkeleton = styled(LoadingBox)`
  width: ${rem(20)};
  height: ${rem(20)};
  border-radius: ${rem(4)};
`

const FilterTextSkeleton = styled(TextLoadingBox)`
  flex: 1;
  height: ${rem(20)};
`

function MerchandiseSearchPageFiltersSkeleton() {
  const intl = useIntl()

  return <CSSBreakpoint min="desktop">
    <FilterPanel>
      <VerticalSpacer gap={24}>
        <VerticalSpacer gap={16}>
          <Heading variant="heading5">
            {intl.formatMessage({
              id: '4V2Y3Frf9B',
              defaultMessage: 'Price',
              description: 'Filter section heading for price',
            })}
          </Heading>
          <VerticalSpacer gap={16}>
            <FilterItem>
              <CheckboxSkeleton />
              <FilterTextSkeleton width="70%" />
              <TextLoadingBox width={30} typography="body-large" />
            </FilterItem>
          </VerticalSpacer>
        </VerticalSpacer>

        <Divider kind="secondary" />

        <VerticalSpacer gap={16}>
          <Heading variant="heading5">
            {intl.formatMessage({
              id: 'BbWKYEskEj',
              defaultMessage: 'Brands',
              description: 'Filter section heading for brands',
            })}
          </Heading>
          <VerticalSpacer gap={16}>
            {Array.from({ length: 5 }).map((_, index) => (
              <FilterItem key={index}>
                <CheckboxSkeleton />
                <FilterTextSkeleton width="70%" />
                <TextLoadingBox width={30} typography="body-large" />
              </FilterItem>
            ))}
          </VerticalSpacer>
        </VerticalSpacer>

        <Divider kind="secondary" />

        <VerticalSpacer gap={16}>
          <Heading variant="heading5">
            {intl.formatMessage({
              id: 'My27y/5qD1',
              defaultMessage: 'Categories',
              description: 'Filter section heading for categories',
            })}
          </Heading>
          <VerticalSpacer gap={16}>
            {Array.from({ length: 5 }).map((_, index) => (
              <FilterItem key={index}>
                <CheckboxSkeleton />
                <FilterTextSkeleton width="70%" />
                <TextLoadingBox width={30} typography="body-large" />
              </FilterItem>
            ))}
          </VerticalSpacer>
        </VerticalSpacer>
      </VerticalSpacer>
    </FilterPanel>
  </CSSBreakpoint>
}

export default MerchandiseSearchPageFiltersSkeleton
